import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
export const CTASection = ({ className }: { className?: string }) => {
  useLocale();

  return (
    <section className={className}>
      <div className="mx-auto max-w-2xl px-6 text-center">
        <h2 className="mb-4 font-bold font-libre-baskerville text-4xl text-landing-heading">
          {t('landing.readyToGetStartedWithRaven')}{' '}
        </h2>
        <p className="mb-8 text-landing-body text-sm leading-relaxed">
          {t('landing.seeHowRavenCanStreamlineYourWorkflowBookA')}{' '}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <a
            className="rounded-md bg-primary px-5 py-2.5 font-semibold text-primary-foreground text-sm transition hover:opacity-90"
            href="#contact"
          >
            {t('landing.bookADemo')}{' '}
          </a>
          <a
            className="rounded-md border border-landing-card-border px-5 py-2.5 font-libre-baskerville font-semibold text-landing-heading text-sm transition hover:bg-landing-active-card-bg"
            href="#contact"
          >
            {t('landing.launchRaven')}{' '}
          </a>
        </div>
      </div>
    </section>
  );
};
